import React, { useEffect, useState } from "react";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";

// Assets
import "~/assets/sass/pages/invest/investList.scss";
import "~/assets/sass/pages/invest/companyDetailModal.scss";

// Pages
import useRequest from "~/common/hooks/useRequest";
import SearchFilter from "./SearchFilter";
import InvestListTable from "./InvestListTable";
import { API_STATE } from "~/common/constants/state";
import pageMaker from "~/common/constants/pageMaker";

const InvestListPage = () => {
	const [companyList, setCompanyList] = useState(null);
	const listRequest = useRequest("post", "vc/invest/company");
	const [totalNum, setTotalNum] = useState(0);
	const [curPage, setCurPage] = useState(1);
	const [searchElement, setSearchElement] = useState({});
	const [searchName, setSearchName] = useState("");
	const [formData, setFormData] = useState({
		round: [],
		field: [],
		page: 1,
		size: 10,
		name: "",
		type: "all",
	});
	const [curTab, setCurTab] = useState("all");
	const pageInfo = pageMaker(formData.page, formData.size, totalNum);
	const [loadingPage, setLoadingPage] = useState(false);

	const handlePage = (pageNum) => {
		setCurPage(pageNum);
		setFormData({ ...formData, page: pageNum });
	};

	const handleSearch = () => {
		setFormData({
			...formData,
			page: 1,
			size: 10,
			round: searchElement.scaleSearch ? searchElement.scaleSearch : [],
			field: searchElement.indSearch ? searchElement.indSearch : [],
			name: searchName,
			type: curTab,
		});
	};

	useEffect(() => {
		setFormData({
			...formData,
			page: 1,
			size: 10,
			round: searchElement.scaleSearch ? searchElement.scaleSearch : [],
			field: searchElement.indSearch ? searchElement.indSearch : [],
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchElement]);

	const resetList = () => {
		setFormData({
			...formData,
			page: curPage,
			type: curTab,
		});
	};

	const onChangeName = (e) => {
		setSearchName(e.target.value);
	};

	useEffect(() => {
		setLoadingPage(true);
		listRequest.call(formData);
	}, [formData]);

	useEffect(() => {
		setLoadingPage(true);
		listRequest.singleCall(formData);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		switch (listRequest.state) {
			case API_STATE.done:
				const requestCompanyData = listRequest.response?.data;
				setTotalNum(requestCompanyData.total);
				setCompanyList(requestCompanyData.list);
				setLoadingPage(false);
				break;
			default:
				break;
		}
	}, [listRequest.state, listRequest.response, setCompanyList]);

	return (
		<NavbarAndSidebarLayout menu={["invest", "list"]} type={"main"}>
			<PageHeader />
			<SearchFilter setSearchElement={setSearchElement} />
			{/* <LoadingPage/> */}
			<InvestListTable
				{...{
					setCurPage,
					pageInfo,
					companyList,
					handlePage,
					onChangeName,
					handleSearch,
					resetList,
					curTab,
					setCurTab,
					loadingPage,
				}}
			/>
		</NavbarAndSidebarLayout>
	);
};

export default InvestListPage;
